import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import HomePage from "./pages/HomePage";
import VideoProductionPage from "./pages/VideoProductionPage";
import PostProductionPage from "./pages/PostProductionPage";
import OnAirIdentityPage from "./pages/OnAirIdentityPage";
import MarketingBrandingPage from "./pages/MarketingBrandingPage";
import WebServicesPage from "./pages/WebServicesPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import WhatsAppChat from "./components/WhatsAppChat";
import ChatbaseWidget from "./components/ChatbaseWidget";
import CookieConsent from "./components/CookieConsent";
import AnalyticsProvider from "./components/AnalyticsProvider";
import { useServiceWorker } from "./hooks/useServiceWorker";

// Service Worker registration component
const ServiceWorkerProvider = ({ children }) => {
  useServiceWorker();
  return children;
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <ServiceWorkerProvider>
          <div className="App">
            <BrowserRouter>
              <AnalyticsProvider>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/video-production" element={<VideoProductionPage />} />
                  <Route path="/post-production" element={<PostProductionPage />} />
                  <Route path="/on-air-identity" element={<OnAirIdentityPage />} />
                  <Route path="/marketing-branding" element={<MarketingBrandingPage />} />
                  <Route path="/web-services" element={<WebServicesPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                  <Route path="/cookie-policy" element={<CookiePolicyPage />} />
                  <Route path="/disclaimer" element={<DisclaimerPage />} />
                  <Route path="/admin" element={<AdminDashboardPage />} />
                </Routes>
                <WhatsAppChat />
                <ChatbaseWidget />
                <CookieConsent />
              </AnalyticsProvider>
            </BrowserRouter>
          </div>
        </ServiceWorkerProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
